var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Corp-level Access"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('IconBtn',{attrs:{"icon":"mdi-plus","title":"Add"},on:{"click":function($event){return _vm.create()}}})]},proxy:true}])},[_c('Table',{staticClass:"mb-5"}),_c('AccessForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }